import { debounce } from 'lodash'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { Spinner } from 'react-bootstrap'
import { Link, useLocation } from 'react-router-dom'
import Select from '../../../components/textFields/AppSelect'
import { toast } from 'react-toastify'
import { Tooltip } from 'react-tooltip'
import 'react-tooltip/dist/react-tooltip.css'
import { KTSVG } from '../../../_metronic/helpers'
import { PageTitle } from '../../../_metronic/layout/core'
import DateComp from '../../../components/dateComponent/DateComp'
import Pagination from '../../../components/pagination/Pagination'
import SearchBarComponent from '../../../components/searchBar/SearchBarComponent'
import RefreshComponent from '../../../components/refreshComponent/RefreshComponent'
import TableHeading from '../../../components/tableHeading/TableHeading'
import TableSettingMenu from '../../../components/tableHeading/TableSettingMenu'
import TextField from '../../../components/textFields/TextField'
import { useDepartmentsLookupQuery, useGetAllDesignationWithoutRoleQuery } from '../../../services/GeneralApi'
import { useGetManagerTeamQuery, useGetCreditCardRequestedUsersQuery } from '../../../services/authApi'
import labelKey from "../../localization/label.json"
import tosterKey from "../../localization/toster.json"
import AddUserModal from '../users/AddUserModal'
import UpdateUserModal from '../users/UpdateUserModal'
import UserActiveConfirmation from '../users/UserActiveConfirmation'
import UserDetailModal from '../users/UserDetailModal'
import NoRecordFound from '../../../components/noRecord/NoRecordFound'
import { LoadingComponent } from '../../../components/loadingComponent/LoadingComponent'
import AccountManager from '../accountManager/AccountManager'
import { useAppSelector } from '../../../hooks';
import { constraintConfig } from '../../../constraintConfig';
import { selectAuth } from '../../../features/authSlice';
import CreditCardRequestsUsers from '../accountManager/CreditCardRequestsUsers'
import CreditCardRequestsUsersApprovalQueue from '../accountManager/CreditCardRequestsUsersApprovalQueue'
import CorpCreditCardsApprovalQueue from '../accountManager/CorpCreditCardsApprovalQueue'
import useColumnVisibility from '../../customHooks/useColumnVisibility'

// Define the location state type
interface LocationState {
    activeTab?: string;
}

type Props = {
    className?: string
}
const FamilyAccount: React.FC<Props> = ({ className }) => {
    const { hiddenColumns, handleToggleColumn } = useColumnVisibility({ pageName: 'teamManagementActiveUsers' });
    const location = useLocation();
    const [showAddUserModal, setShowAddUserModal] = useState(false);
    const {
        userAccountID,
        roleID,
        email,
        isAllowCorporateCreditCardApprovalQueue,
        isAllowCorporateCreditCardOrderRequests,
    } = useAppSelector(selectAuth);

    const { data: corpCcRequestedCountData } = useGetCreditCardRequestedUsersQuery(
        {
            pageNumber: 1,
            pageSize: 1,
            sortBy: 'ccRequestedDate',
            sortOrder: 'desc',
            searchStr: '',
            filterByDepartment: '',
            filterByDesignation: '',
            filterByStatus: String(constraintConfig.ccCardRequestStatus.Requested),
            filterByAssignedApproverEmail: email || undefined,
        },
        {
            skip: !isAllowCorporateCreditCardApprovalQueue || !email,
            refetchOnMountOrArgChange: true,
        }
    );
    const corpCcRequestedCount = corpCcRequestedCountData?.result?.totalRecords ?? 0;
    const [page, setPage] = useState(1)
    const [pageSize, setPageSize] = useState(10);
    const [searchStr, setSearchStr] = useState(''); // debounce search
    const [immediateSearchStr, setImmediateSearchStr] = useState('');
    const [sortBy, setSortBy] = useState("createDT");
    const [sortOrder, setSortOrder] = useState("desc");
    const [managerId] = useState(userAccountID);
    const [filterByDepartment, setFilterByDepartment] = useState('');
    const [filterByDesignation, setFilterByDesignation] = useState('');
    const [filterByStatus, setFilterByStatus] = useState('');
    const [isChecked] = useState(false)

    const [localFilterByDepartment, setLocalFilterByDepartment] = useState('');
    const [localFilterByDesignation, setLocalFilterByDesignation] = useState('');
    const [isApplyingFilters, setIsApplyingFilters] = useState(false);

    const [sortedColumn, setSortedColumn] = useState("createDT");
    const { data: designationLookUp } = useGetAllDesignationWithoutRoleQuery('');
    const { data: deparmentLookUp } = useDepartmentsLookupQuery('');
    const { data: getManagerTeam,
        isError: getManagerIsError,
        isLoading: getManagerIsLoading,
        refetch,
        isSuccess } = useGetManagerTeamQuery({
            pageNumber: page,
            pageSize: pageSize,
            sortBy: sortBy,
            sortOrder: sortOrder,
            searchStr: searchStr,
            managerId: managerId,
            filterByDepartment: filterByDepartment,
            filterByDesignation: filterByDesignation,
            filterByStatus: filterByStatus
        });
    // pagination
    const handlePageClick = (e: any) => {
        setPage(e.selected + 1);
    };
    const handlePageSizeChange = (e: any) => {
        const newSize = parseInt(e.target.value);
        setPageSize(newSize);
        setPage(1); // Reset page number to 1
    };
    const handleSort = (property: string) => {
        setSortBy(property);
        if (sortedColumn === property) {
            setSortOrder(prevSortOrder => (prevSortOrder === "asc" ? "desc" : "asc"));
        } else {
            setSortedColumn(property);
            setSortOrder("asc");
        }
    };

    const handleSearchChange = (e: any) => {
        const { value } = e.target;
        setImmediateSearchStr(value); // Update immediate search state

        delayedSearch(value); // Update debounced search state
        setPage(1)
    };

    const delayedSearch = useCallback(
        debounce((searchValue) => {
            setSearchStr(searchValue);
        }, 500),
        []
    );
    const handleDeparmentChange = (selectedOption: any) => {
        setLocalFilterByDepartment(selectedOption.value);
        // const departmentName = selectedOption.value.split(' - ')[1] || selectedOption.value;
        // setLocalFilterByDepartment(departmentName);
    };
    const handleDesignationChange = (selectedOption: any) => {
        setLocalFilterByDesignation(selectedOption.value);
    };
    const handleFilterStatus = (selectedOption: any) => {
        setFilterByStatus(selectedOption.value);
    };

    const [showUserDetailModal, setShowUserDetailModal] = useState(false)
    const [userDetailData, setuserDetailData] = useState({});

    const userDetailHandler = () => {
        setShowUserDetailModal((prev) => !prev);
    };

    const [showUpdateUserModal, setShowUpdateUserModal] = useState(false)
    const [editData, setEditData] = useState({});

    const editUserHandler = () => {
        setShowUpdateUserModal((prev) => !prev);
    };
    const [showConfirmationActiveUserModal, setShowConfirmationActiveUserModal] = useState(false)
    const expenseConfirmationModalHandler = () => {
        setShowConfirmationActiveUserModal((prev) => !prev);
    };
    useEffect(() => {
        if (getManagerIsError) {
            toast.error("Some thing went wrong")
        }
    }, [getManagerIsError])

    const tableRef = useRef(null);
    useEffect(() => {
        if (searchStr === "" ||
            sortOrder === "" ||
            sortBy === "") {
            refetch();
        }
    }, [searchStr, sortOrder, sortBy]);

    const [prevModalState, setPrevModalState] = useState({
        showUserDetailModal: false,
        showUpdateUserModal: false,
        showAddUserModal: false,
        showConfirmationActiveUserModal: false,
    });

    useEffect(() => {
        setPrevModalState({
            showUserDetailModal: showUserDetailModal,
            showUpdateUserModal: showUpdateUserModal,
            showAddUserModal: showAddUserModal,
            showConfirmationActiveUserModal: showConfirmationActiveUserModal,
        });
    }, [
        showUserDetailModal,
        showUpdateUserModal,
        showAddUserModal,
        showConfirmationActiveUserModal,
    ]);

    useEffect(() => {
        if (
            (prevModalState.showUserDetailModal && !showUserDetailModal) ||
            (prevModalState.showUpdateUserModal && !showUpdateUserModal) ||
            (prevModalState.showAddUserModal && !showAddUserModal) ||
            (prevModalState.showConfirmationActiveUserModal && !showConfirmationActiveUserModal)
        ) {
            refetch();
        }
    }, [
        showUserDetailModal,
        showUpdateUserModal,
        showAddUserModal,
        showConfirmationActiveUserModal,
        prevModalState.showUserDetailModal,
        prevModalState.showUpdateUserModal,
        prevModalState.showAddUserModal,
        prevModalState.showConfirmationActiveUserModal,
        refetch,
    ]);

    const [pageTitle, setPageTitle] = useState(labelKey.teamManagement);
    useEffect(() => {
        // Check the current route and set the selected value accordingly
        if (location.pathname === '/active/team-management') {
            setFilterByStatus('active');
            setPageTitle('Active Reportees')
        } else if (location.pathname === '/all/team-management') {
            setPageTitle('All Reportees')
        } else {
            setFilterByStatus('');
            setPageTitle(labelKey.teamManagement);
        }

    }, [location.pathname]);

    const applyFilters = () => {
        setIsApplyingFilters(true);
        setFilterByDepartment(localFilterByDepartment);
        setFilterByDesignation(localFilterByDesignation);
        setPage(1)
    };
    const resetFilters = () => {
        setFilterByDepartment('');
        setFilterByDesignation('');
        setLocalFilterByDepartment('');
        setLocalFilterByDesignation('');
        closeMenu();
    }
    const debouncedRefetch = debounce(() => {
        refetch().finally(() => {
            setIsApplyingFilters(false);
        });
    }, 300);
    useEffect(() => {
        if (isApplyingFilters) {
            debouncedRefetch();
        }
        if (isSuccess) {
            closeMenu();
        }
    }, [isApplyingFilters, isSuccess]);

    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const toggleMenu = () => {
        setIsMenuOpen(prevState => !prevState);
    };
    const closeMenu = () => {
        setIsMenuOpen(false);
    };
    const [tabChange, setTabChange] = useState('');

    // Set active tab from location state with proper typing
    const [activeTab, setActiveTab] = useState(() => {
        // Type assertion for location.state
        const state = location.state as LocationState;
        // Check if location state has activeTab
        if (state && state.activeTab) {
            return state.activeTab;
        }
        return 'first';
    });

    const handleTabSelect = (selectedKey: any) => {
        setActiveTab(selectedKey);
        setTabChange(selectedKey);
        // Clear the location state after tab change
        window.history.replaceState({}, document.title);
    };

    const handleRefresh = () => {
        refetch().then(() => {
            if (isSuccess) {
                toast.success(tosterKey.dataRefreshedSuccesfully || "Data refreshed successfully");
            }
        });
    };

    return (
        <>
            <div className='d-flex align-items-center mb-4'>
                <div className='ss-compact-pill-group' role='group' aria-label='Team management tabs'>
                    <button
                        type='button'
                        className={`ss-compact-pill-btn ${activeTab === 'first' ? 'active' : ''}`}
                        onClick={() => handleTabSelect('first')}
                    >
                        Active Users
                    </button>
                    <button
                        type='button'
                        className={`ss-compact-pill-btn ${activeTab === 'second' ? 'active' : ''}`}
                        onClick={() => handleTabSelect('second')}
                    >
                        Onboarding Users Request
                    </button>
                    <button
                        type='button'
                        className={`ss-compact-pill-btn ${activeTab === 'third' ? 'active' : ''}`}
                        onClick={() => handleTabSelect('third')}
                    >
                        Corp Credit Card Requests
                    </button>
                    {!!isAllowCorporateCreditCardApprovalQueue && (
                        <button
                            type='button'
                            className={`ss-compact-pill-btn d-flex align-items-center gap-2 ${activeTab === 'ccApprovalQueue' ? 'active' : ''}`}
                            onClick={() => handleTabSelect('ccApprovalQueue')}
                        >
                            Corp Credit Cards Approval Queue
                            {corpCcRequestedCount > 0 && (
                                <span className="badge badge-danger">{corpCcRequestedCount} Requested</span>
                            )}
                        </button>
                    )}
                    {isAllowCorporateCreditCardOrderRequests && (
                        <button
                            type='button'
                            className={`ss-compact-pill-btn ${activeTab === 'fourth' ? 'active' : ''}`}
                            onClick={() => handleTabSelect('fourth')}
                        >
                            Corp Credit Card Order Requests
                        </button>
                    )}
                </div>
            </div>

            {activeTab === 'first' && (
                <>
                    <AddUserModal
                        show={showAddUserModal}
                        handleClose={() => setShowAddUserModal(false)}
                    />
                    <UpdateUserModal
                        show={showUpdateUserModal}
                        handleClose={() => setShowUpdateUserModal(false)}
                        data={editData}
                    />
                    <UserDetailModal
                        show={showUserDetailModal}
                        handleClose={() => setShowUserDetailModal(false)}
                        data={userDetailData}
                    />
                    <UserActiveConfirmation
                        show={showConfirmationActiveUserModal}
                        handleClose={() => setShowConfirmationActiveUserModal(false)}
                        data={editData}
                        isChecked={isChecked}
                    />

                    <PageTitle breadcrumbs={[]}>{pageTitle}</PageTitle>
                    <div className='card'>
                        <div className='card-header align-items-end border-0 pt-5'>
                            <div className='d-md-flex align-items-start gap-2'>
                                <div className='w-md-250px'>
                                    <SearchBarComponent
                                        placeholder='User'
                                        value={immediateSearchStr}
                                        onChange={handleSearchChange}
                                        className='w-100'
                                        mainClassName='my-0'
                                    />
                                </div>
                                <div className='w-35px align-self-end mb-1'>
                                    <RefreshComponent onClick={handleRefresh} />
                                </div>
                            </div>
                            <div className='d-flex align-items-center ms-auto gap-2'>
                                {roleID === constraintConfig.roleID.role4 && (
                                    <Link to='/newuserrequestbymanager' className='btn btn-sm btn-primary'>
                                        <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-2' />
                                        New User Request
                                    </Link>
                                )}
                                <div className='position-relative'>
                                    <button
                                        type='button'
                                        className='btn btn-sm btn-light-primary d-flex align-items-center'
                                        data-kt-menu-placement='bottom-end'
                                        onClick={toggleMenu}
                                    >
                                        <KTSVG path='/media/icons/duotune/general/gen031.svg' className='svg-icon-2' />
                                        {labelKey.filter}
                                    </button>
                                    <div
                                        className={`menu menu-sub menu-sub-dropdown w-300px w-md-325px ${isMenuOpen ? 'show position-absolute mt-3' : ''}`}
                                        style={{ right: "5px", zIndex: 105 }}
                                    >
                                        <div className='px-7 py-5'>
                                            <div className='fs-5 text-dark fw-bold'>{labelKey.filterOptions}</div>
                                        </div>
                                        <div className='separator border-gray-200'></div>
                                        <div className='px-7 py-5'>
                                            <div className='mb-5'>
                                                <label className='form-label fs-5 fw-bold'>{labelKey.department}</label>
                                                <Select
                                                    options={[
                                                        ...(deparmentLookUp?.result || []).map((option: any) => ({
                                                            value: option.value,
                                                            label: option?.value,
                                                        })),
                                                    ]}
                                                    placeholder={`${localFilterByDepartment ? `${localFilterByDepartment}` : 'Select Department'}`}
                                                    value={localFilterByDepartment}
                                                    onChange={handleDeparmentChange}
                                                />
                                            </div>
                                            <div className='mb-5'>
                                                <label className='form-label fs-5 fw-bold'>{labelKey.designation}</label>
                                                <Select
                                                    options={[
                                                        ...(designationLookUp?.result || []).map((option: any) => ({
                                                            value: option.value,
                                                            label: option?.value,
                                                        })),
                                                    ]}
                                                    placeholder={`${localFilterByDesignation ? `${localFilterByDesignation}` : 'Select Designation'}`}
                                                    value={localFilterByDesignation}
                                                    onChange={handleDesignationChange}
                                                />
                                            </div>
                                        </div>
                                        <div className='separator border-gray-200'></div>
                                        <div className='px-7 py-5'>
                                            <button className='btn btn-primary pull-right' onClick={applyFilters}>
                                                {isApplyingFilters ? (
                                                    <>
                                                        <span>loading...</span>
                                                        <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                                                    </>
                                                ) : "Apply Filters"}
                                            </button>
                                            <button className='btn btn-danger pull-right me-3' onClick={resetFilters}>Reset Filters</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='card-body py-3'>
                            <Tooltip id="update-user-1" place="left" positionStrategy="fixed" />
                            <div className='table-responsive table-height'>
                                <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4' ref={tableRef}>
                                    <thead>
                                        <tr className='fw-bold text-muted'>
                                            {hiddenColumns.includes('sr') && (
                                                <TableHeading
                                                    label={labelKey.sr}
                                                    columnId='sr'
                                                    className="ps-4 w-60px text-center"
                                                />
                                            )}
                                            {hiddenColumns.includes('firstName') && (
                                                <TableHeading
                                                    label={labelKey.name}
                                                    columnId='firstName'
                                                    sortedColumn={sortedColumn}
                                                    sortOrder={sortOrder}
                                                    handleSort={handleSort}
                                                    className='min-w-120px'
                                                />
                                            )}
                                            {hiddenColumns.includes('department') && (
                                                <TableHeading
                                                    label={labelKey.department}
                                                    columnId='department'
                                                    sortedColumn={sortedColumn}
                                                    sortOrder={sortOrder}
                                                    handleSort={handleSort}
                                                    className='min-w-120px'
                                                />
                                            )}
                                            {hiddenColumns.includes('designation') && (
                                                <TableHeading
                                                    label={labelKey.designation}
                                                    columnId='designation'
                                                    sortedColumn={sortedColumn}
                                                    sortOrder={sortOrder}
                                                    handleSort={handleSort}
                                                    className='min-w-120px'
                                                />
                                            )}
                                            {hiddenColumns.includes('cellPhone') && (
                                                <TableHeading
                                                    label={labelKey.cellPhone}
                                                    columnId='cellPhone'
                                                    sortedColumn={sortedColumn}
                                                    sortOrder={sortOrder}
                                                    handleSort={handleSort}
                                                    className='min-w-140px'
                                                />
                                            )}
                                            {hiddenColumns.includes('createDT') && (
                                                <TableHeading
                                                    label={labelKey.createdDate}
                                                    columnId='createDT'
                                                    sortedColumn={sortedColumn}
                                                    sortOrder={sortOrder}
                                                    handleSort={handleSort}
                                                    className='min-w-140px'
                                                />
                                            )}
                                            <th className='text-end rounded-end pe-2 border-0 sticky-table-actions'>
                                                {hiddenColumns.includes('actions') && (
                                                    <>{labelKey.action}</>
                                                )}
                                                <TableSettingMenu>
                                                    <TextField
                                                        rightLabel={labelKey.sr}
                                                        type="checkbox"
                                                        onChange={() => handleToggleColumn("sr")}
                                                        checked={hiddenColumns.includes('sr')}
                                                        fieldClass='mb-4'
                                                    />
                                                    <TextField
                                                        rightLabel={labelKey.name}
                                                        type="checkbox"
                                                        onChange={() => handleToggleColumn("firstName")}
                                                        checked={hiddenColumns.includes('firstName')}
                                                        fieldClass='mb-4'
                                                    />
                                                    <TextField
                                                        rightLabel={labelKey.department}
                                                        type="checkbox"
                                                        onChange={() => handleToggleColumn("department")}
                                                        checked={hiddenColumns.includes('department')}
                                                        fieldClass='mb-4'
                                                    />
                                                    <TextField
                                                        rightLabel={labelKey.designation}
                                                        type="checkbox"
                                                        onChange={() => handleToggleColumn("designation")}
                                                        checked={hiddenColumns.includes('designation')}
                                                        fieldClass='mb-4'
                                                    />
                                                    <TextField
                                                        rightLabel={labelKey.cellPhone}
                                                        type="checkbox"
                                                        onChange={() => handleToggleColumn("cellPhone")}
                                                        checked={hiddenColumns.includes('cellPhone')}
                                                        fieldClass='mb-4'
                                                    />
                                                    <TextField
                                                        rightLabel={labelKey.createdDate}
                                                        type="checkbox"
                                                        onChange={() => handleToggleColumn("createDT")}
                                                        checked={hiddenColumns.includes('createDT')}
                                                        fieldClass='mb-4'
                                                    />
                                                    <TextField
                                                        rightLabel={labelKey.action}
                                                        type="checkbox"
                                                        onChange={() => handleToggleColumn("actions")}
                                                        checked={hiddenColumns.includes('actions')}
                                                        fieldClass='mb-4'
                                                    />
                                                </TableSettingMenu>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {!getManagerIsLoading && (
                                            <>
                                                {getManagerTeam?.result?.data?.length > 0 ? (
                                                    getManagerTeam?.result?.data?.map((data: any, index: any) => (
                                                        <tr key={data.userAccountID || index}>
                                                            {hiddenColumns.includes('sr') && (
                                                                <td className='text-center ps-4'>
                                                                    {(page - 1) * pageSize + index + 1}
                                                                </td>
                                                            )}
                                                            {hiddenColumns.includes('firstName') && (
                                                                <td>
                                                                    <Link to={`/user-profile/expense-items/${data.userAccountID}`}>
                                                                        <div className="d-flex align-items-center">
                                                                            <div className="symbol symbol-circle symbol-50px overflow-hidden me-3">
                                                                                <div className="symbol-label fs-3 bg-light-info text-info text-capitalize">{data?.firstName?.charAt(0)}</div>
                                                                            </div>
                                                                            <div className="d-flex flex-column">
                                                                                <span className="text-gray-800 fw-semibold mb-1 text-capitalize">{data?.firstName} {data?.middleName} {data?.lastName}</span>
                                                                                <span className='text-lowercase'>{data?.email}</span>
                                                                            </div>
                                                                        </div>
                                                                    </Link>
                                                                </td>
                                                            )}
                                                            {hiddenColumns.includes('department') && (
                                                                <td>{data?.department?.title ? data?.department?.title : "N/A"}</td>
                                                            )}
                                                            {hiddenColumns.includes('designation') && (
                                                                <td>{data?.designation?.title ? data?.designation?.title : "N/A"}</td>
                                                            )}
                                                            {hiddenColumns.includes('cellPhone') && (
                                                                <td>{data?.cellPhone ? data?.cellPhone : "N/A"}</td>
                                                            )}
                                                            {hiddenColumns.includes('createDT') && (
                                                                <td><DateComp formattedDate={data?.createDT} /></td>
                                                            )}
                                                            <td className='text-end sticky-table-actions'>
                                                                {hiddenColumns.includes('actions') && (
                                                                    <div className='d-flex align-items-center justify-content-end gap-2'>
                                                                        <Link
                                                                            to={`/user-profile/expense-items/${data.userAccountID}`}
                                                                            className="btn btn-sm btn-primary"
                                                                        >
                                                                            View Reports
                                                                        </Link>
                                                                        <div
                                                                            data-tooltip-id="update-user-1"
                                                                            data-tooltip-content='User Details'
                                                                            data-tooltip-place="left"
                                                                            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                                                            onClick={() => {
                                                                                setuserDetailData(data?.userAccountID);
                                                                                userDetailHandler();
                                                                            }}
                                                                        >
                                                                            <KTSVG
                                                                                path='/media/icons/duotune/arrows/arr064.svg'
                                                                                className='svg-icon-3'
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan={10}>
                                                            <NoRecordFound />
                                                        </td>
                                                    </tr>
                                                )}
                                            </>
                                        )}
                                        {getManagerIsLoading && (
                                            <tr>
                                                <td colSpan={10} className="text-center">
                                                    <LoadingComponent />
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                            <Pagination
                                totalResult={getManagerTeam?.result?.totalRecords === 0 ? 0 : ((getManagerTeam?.result?.pageNumber - 1) * getManagerTeam?.result?.pageSize) + 1}
                                toResult={getManagerTeam?.result?.totalRecords === 0 ? 0 : Math.min(getManagerTeam?.result?.pageNumber * getManagerTeam?.result?.pageSize, getManagerTeam?.result?.totalRecords)}
                                ofResult={getManagerTeam?.result?.totalRecords}
                                onChange={handlePageSizeChange}
                                pageSize={pageSize}
                                onPageChange={handlePageClick}
                                pageCount={getManagerTeam?.result?.totalPages || 0}
                                currentPage={page}
                            />
                        </div>
                    </div>
                </>
            )}

            {activeTab === 'second' && <AccountManager tabChange={tabChange} />}
            {activeTab === 'third' && <CreditCardRequestsUsers />}
            {!!isAllowCorporateCreditCardApprovalQueue && activeTab === 'ccApprovalQueue' && (
                <CorpCreditCardsApprovalQueue />
            )}
            {isAllowCorporateCreditCardOrderRequests && activeTab === 'fourth' && (
                <CreditCardRequestsUsersApprovalQueue />
            )}
        </>
    )
}

export default FamilyAccount